import { Route } from 'types/route.type';
import FarmSetup from 'views/production-systems/features/farm-setup/farm-setup';

export const routes: Route[] = [
  {
    path: '/production-systems/farm-setup/:globalSiteId?',
    component: FarmSetup,
    id: 'productionSystems.farmSetup.title',
  },
];
